<template>
  <div class="policy-detail">
    <Card>
      <div v-if="loading" class="progress-wrapper d-flex justify-center align-center">
        <Loader/>
      </div>
      <div v-else-if="!detail" class="not-found">
        文章不存在
      </div>
      <v-row v-else class="pa-4 pa-sm-7">
        <v-col class="col-12 mb-4 pa-0">
          <div class="title mb-6">{{detail.title}}</div>
          <div class="date align-self-end">发布日期：{{formatTime(detail.date)}}</div>
        </v-col>
        <v-col class="col-12 pa-0 d-flex flex-column">
          <div class="content mb-4" v-html="detail.content"></div>
        </v-col>
      </v-row>
    </Card>
  </div>
</template>

<script>
import { Card, Loader } from '@/components/UI'
import { formatTime } from '@/utils'
import Tcb from '@/tcb'
export default {
  name: 'PolicyDetail',
  components: { Card, Loader },
  props: ['id'],
  data: () => ({
    loading: true,
    detail: null
  }),
  methods: {
    formatTime,
    showHtml (str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, '\'')
    },
    async getDetail (id) {
      const db = Tcb.database()
      try {
        const query = db.collection('policy_statute').where({
          _id: id
        })
        const res = await query.get()
        if (res.data.length) {
          const { title, content, datetime: date } = res.data[0]
          this.detail = {
            title,
            content: this.showHtml(content),
            date: new Date(date)
          }
          document.title = this.detail.title
        }
        // console.log(res)
      } catch (error) {
        // console.log(error)
      }
      this.loading = false
    }
  },
  mounted () {
    this.getDetail(this.id)
  }
}
</script>

<style lang="scss" scoped>

.progress-wrapper {
  width: 100%;
  height: 300px;
}
.content {
  width: 100%;
}
.date,
.title {
  text-align: center;
}
.title {
  font-size: 32px!important;
}
</style>
